import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ThemeTypes, trailerTypes, UserProfileTrailerTypes, LanguageTypes } from "@/utils/constants";
import { API } from "@/services/API";

const initialState = {
  data: null,
  loading: false,
  getError: null,
  updateError: null,
};

export const getUserProfile = createAsyncThunk("profile/get", async (_, { rejectWithValue }) => {
  return API.get("/user/preferences")
    .then((response) => {
      return {
        appLanguage: LanguageTypes.find((language) => language.id === response.appLanguage) || LanguageTypes[0],
        webTheme: ThemeTypes[response.appearance] || ThemeTypes.dark,
        trailerType: UserProfileTrailerTypes[response.trailerType] || trailerTypes[0],
        predictionModuleEnabled: response.predictionModuleEnabled,
      };
    })
    .catch((error) => rejectWithValue(error));
});

export const updateUserProfile = createAsyncThunk("profile/update", async ({ appLanguage, webTheme, trailerType }, { rejectWithValue }) => {
  return API.post("user/preferences", {
    appLanguage: appLanguage.id,
    appearance: webTheme.id,
    trailerType: trailerType.id,
    maxDeadHead: 0,
    predictionModuleEnabled: true,
    userId: "",
  })
    .then(() => {
      return {
        appLanguage,
        webTheme,
        trailerType,
      };
    })
    .catch((error) => rejectWithValue(error));
});

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.data = null;
      state.getError = null;
      state.updateError = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.loading = true;
        state.getError = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.getError = null;
      })
      .addCase(getUserProfile.rejected, (state) => {
        state.getError = "Error fetching user profile";
        console.log("Error fetching user profile");
        state.loading = false;
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.updateError = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.updateError = null;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.updateError = "Error updating user profile";
        console.log("Error updating user profile", action);
        state.loading = false;
      });
  },
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
